module.exports = __webpack_public_path__ + "static/media/info.e57c0192.png";